import { __rest } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';

const Label = (_a) => {
    var { value, className } = _a, htmlLabelProps = __rest(_a, ["value", "className"]);
    return (React.createElement("label", Object.assign({}, htmlLabelProps, { className: className }), value));
};

export { Label as default };
//# sourceMappingURL=Label.js.map
